export function chargeRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_CHARGE_START":           
        case "FETCH_CHARGES_START":                                 
        case "UPDATE_CHARGE_START":                                 
        case "UPDATE_FETCH_CHARGE_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_CHARGE_FULFILLED":           
        case "FETCH_CHARGES_FULFILLED":                                 
        case "UPDATE_CHARGE_FULFILLED":                                 
        case "UPDATE_FETCH_CHARGE_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_CHARGE_ERROR":
        case "FETCH_CHARGES_ERROR":
        case "UPDATE_CHARGE_ERROR":
        case "UPDATE_FETCH_CHARGE_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}